import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs/Observable';
import { RouteLabels } from '../route-labels';
import { AdalService } from './adal.service';

@Injectable()
export class AuthGuardService implements CanActivate {

    constructor(private authService: AuthService, private adalService : AdalService, private router: Router) { }
    // canActivate() {        
    //     let isLoggedIn = this.authService.isLoggedIn;
    //     // isLoggedIn.subscribe((loggedin) => {
    //     //     console.log('auth guard...')
    //     //     if (!loggedin) {
    //     //         this.authService.startSigninMainWindow();
    //     //         //this.router.navigate(['unauthorized']);
    //     //     }
    //     // });
    //     let o = new Observable();
    //     o.
    //     return isLoggedIn;

    // }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
      ): Observable<boolean>|Promise<boolean>|boolean {
          console.log("Auth Guard: ...");
          // if(this.authService.isLoggedIn()) {
          //   return true;
          // }
          // else{
          //   this.router.navigate([RouteLabels.LOGIN]);
          // }

          if(this.adalService.isAuthenticated) {
            console.log(this.adalService.userInfo);
            return true;
          }
          else{
            //this.router.navigate([RouteLabels.LOGIN]);
            this.adalService.login();
          }
      }

}



// WEBPACK FOOTER //
// ./src/app/services/auth-guard.service.ts